// @flow
import * as actionTypes from "../constants/actionTypes";
import type { Entities } from "../types/entities";

export type GetMainFiltersAction = {
  type: "GET_MAIN_FILTERS"
};
export type GetMainFiltersSuccessAction = {
  type: "GET_MAIN_FILTERS_SUCCESS",
  payload: { typologies: Entities, markets: Entities }
};
export type GetMainFiltersErrorAction = {
  type: "GET_MAIN_FILTERS_ERROR",
  payload: { error: string }
};
export type GetFiltersByTypologyAction = {
  type: "GET_FILTERS_BY_TYPOLOGY"
};
export type GetFiltersByTypologySuccessAction = {
  type: "GET_FILTERS_BY_TYPOLOGY_SUCCESS",
  payload: { categories: Entities, tags: Entities, properties: Entities }
};
export type GetFiltersByTypologyErrorAction = {
  type: "GET_FILTERS_BY_TYPOLOGY_ERROR",
  payload: { error: string }
};

export type Action =
  | GetMainFiltersAction
  | GetMainFiltersSuccessAction
  | GetMainFiltersErrorAction
  | GetFiltersByTypologyAction
  | GetFiltersByTypologySuccessAction
  | GetFiltersByTypologyErrorAction;

export function getMainFilters(): Action {
  return {
    type: actionTypes.GET_MAIN_FILTERS
  };
}

export function getMainFiltersSuccess(
  typologies: Entities,
  markets: Entities
): Action {
  return {
    type: actionTypes.GET_MAIN_FILTERS_SUCCESS,
    payload: {
      typologies,
      markets
    }
  };
}

export function getMainFiltersError(error: string): Action {
  return {
    type: actionTypes.GET_MAIN_FILTERS_ERROR,
    payload: {
      error
    }
  };
}

export function getFiltersByTypology(): Action {
  return {
    type: actionTypes.GET_FILTERS_BY_TYPOLOGY
  };
}

export function getFiltersByTypologySuccess(
  categories: Entities,
  tags: Entities,
  properties: Entities
): Action {
  return {
    type: actionTypes.GET_FILTERS_BY_TYPOLOGY_SUCCESS,
    payload: {
      categories,
      tags,
      properties
    }
  };
}

export function getFiltersByTypologyError(error: string): Action {
  return {
    type: actionTypes.GET_FILTERS_BY_TYPOLOGY_ERROR,
    payload: {
      error
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/filters.js